import React from 'react';
import { TextInput, Pill } from '../ui';
import { cn } from '../../design-system/cn';

export const LOCK_STAKE_PRESETS = [5, 10, 20, 50, 100];

export default function StakeChipRow({
  value,
  onChange,
  max = 500,
  className = '',
}) {
  const [customMode, setCustomMode] = React.useState(
    () => !LOCK_STAKE_PRESETS.includes(Number(value)) && Number(value) > 0
  );

  React.useEffect(() => {
    if (LOCK_STAKE_PRESETS.includes(Number(value))) setCustomMode(false);
  }, [value]);

  return (
    <div className={className}>
      <div className="flex flex-wrap gap-2">
        {LOCK_STAKE_PRESETS.map((amount) => {
          const active = !customMode && Number(value) === amount;
          const overMax = amount > max;
          return (
            <Pill
              key={amount}
              radius="control"
              size="chip"
              active={active}
              disabled={overMax}
              onClick={() => {
                setCustomMode(false);
                onChange(amount);
              }}
              className={cn('min-w-[3.25rem] tabular-nums normal-case tracking-normal')}
            >
              ${amount}
            </Pill>
          );
        })}
        <Pill
          radius="control"
          size="sm"
          active={customMode}
          onClick={() => setCustomMode(true)}
        >
          Custom
        </Pill>
      </div>
      {customMode && (
        <TextInput
          type="number"
          min={1}
          max={max}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="mt-2 bg-black/50 border-gray-800 focus:border-emerald-500/50 text-sm font-black"
        />
      )}
      <p className="text-[9px] text-gray-500 font-bold uppercase tracking-widest mt-1.5">
        Max ${max} per player
      </p>
    </div>
  );
}
